// Shared by the contact step and its validate in config.js. Kept out of
// LeadContact so config doesn't depend on a component module — tests that mock
// the step component would otherwise take these down with it.

// b2b leads book a sales call instead of typing their details — the same gate
// the success screen uses for its "Schedule Now" link
export const usesScheduler = data =>
  !!data.occasion?.groups?.includes('b2b') && data.meta?.contact_mode !== 'manual'

export const isMeetingBooked = data => !!data.meta?.hubspot_meeting?.booked
